<template>
  <v-container fluid>
  <span>Areas</span>
    <v-data-table 
      dense
      :headers="headers"
      :items="items"
      item-key="Id" 
      display-text="AreaName"
      class="elevation-1 mt-4"
      @click:row="onClickRow($event)"
      :items-per-page="itemsPerPage"
      hide-default-footer
    >
    <template slot="no-data">No records found.</template>
    </v-data-table>
    <v-overlay opacity="0" v-if="loading">
      <v-progress-circular
        indeterminate
        color="red"
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </v-container>
</template>
<style lang="scss">
</style>
<script>
import api from '@/api.js';

export default {
  name: "countries-view",

  props: {
  },

  data: () => ({
    loading: false,
    itemsPerPage: -1,
    items: [],
    headers: [],
    search: null
  }),

  async created() {
    const me = this;
    me.headers = me.createHeaders();
    me.refresh();
  },

  updated() {
    document.title = "Jura Orga App | Areas";
  },

  methods: {
    async refresh() {
       const me = this;
       me.loading = true;
       const res = await api.get(`areas`);
       me.items = res.data;
       me.loading = false;
    },

    addNew() {
      this.$router.push(`areas/-1`);
    },

    onClickRow(e) {
      this.$router.push(`areas/${e.Id}`);
    },

    createHeaders() {
      //const me = this;
      const headers = [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "AreaName",
        },
      ];
      return headers;
    },
  },
};
</script>